import { useCallback, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import bookActions from 'store/modules/booking'
import bookSelectors from 'store/selectors/booking'
import adminActions from 'store/modules/admin'
import adminSelectors from 'store/selectors/admin'
import routerSelectors from 'store/selectors/router'
import routerActions from 'store/modules/router'
import useCalendar from './useCalendar'

const useMoveCalendar = ({
  project,
  bookingform,
  config,
  initialDate,
} = {}) => {
  const dispatch = useDispatch()
  
  const slotFilter = useSelector(adminSelectors.calendarSlotFilter)
  const setSlotFilter = useCallback((value) => {
    dispatch(adminActions.setCalendarSlotFilter(value))
  }, [])

  const condensed = useSelector(adminSelectors.calendarCondensed)
  const setCondensed = useCallback((value) => {
    dispatch(adminActions.setCalendarCondensed(value))
  }, [])

  const calendarConfig = useMemo(() => {
    return config ? config.calendar_config || {} : {}
  }, [
    config,
  ])

  const calendarConfigCondensed = useMemo(() =>{
    return calendarConfig.condensed ? true : false
  }, [
    calendarConfig,
  ])

  const baseCalendar = useCalendar({
    project,
    bookingform,
    admin: true,
    days: 3,
    initialDate,
    config,
    calendarConfig,
    condensed: calendarConfigCondensed,
    slotFilter: 'canBook',
    dataSelector: adminSelectors.moveCalendar,
    loadDataAction: adminActions.loadMoveCalendar,
  })

  return Object.assign({}, baseCalendar, {
    setSlotFilter,
    setCondensed,
  })

}

export default useMoveCalendar